export default "__VITE_ASSET__BTyzG60J__"